let env = process.env.CURRENT_ENV?.toUpperCase() ?? 'DEV';
if (env === 'QA') {
  env = 'DEV';
}

export const ADVICE_INDEX = {
  fr: `FR_contentful_Advice_${env}`,
  de: `DE_contentful_Advice_${env}`,
  es: `ES_contentful_Advice_${env}`,
  en: `EN_contentful_Advice_${env}`,
  it: `IT_contentful_Advice_${env}`,
};

export const RECIPE_INDEX = {
  fr: `FR_contentful_Recipe_${env}`,
  de: `DE_contentful_Recipe_${env}`,
  es: `ES_contentful_Recipe_${env}`,
  en: `EN_contentful_Recipe_${env}`,
  it: `IT_contentful_Recipe_${env}`,
};
